import axios from 'axios';
import router from '../router/index';
import {MessageBox, Message, Loading} from 'element-ui';
import store from '../store';
import * as types from '../store/mutation-types';

let loading;

function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0.7)'
    });
}

function endLoading() {
    loading.close();
}

let needLoadingRequestCount = 0;

export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        endLoading();
    }
}

let index = store.state.talgIndex;
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true; // 跨域默认不带cookie
axios.defaults.baseUrl = process.env.PROTOCOL + "://" + process.env.API_HOST + "/api";
axios.interceptors.request.use(
    config => {
        if (!(config.url.indexOf("http") > -1 || config.url.indexOf("https") > -1)) {
            config.url = config.baseUrl + config.url;
        }
        if (store.state.token) {
            config.headers.Authorization = store.state.token;
        }
        let link = 'https://api.b2bdev.codepku.com/api/codepku/institution/todos/mine';
        if (config.url != link) {
            showFullScreenLoading();
        }
        return config;
    }, err => {
        return Promise.reject(err);
    });

axios.interceptors.response.use(
    response => {
        tryHideFullScreenLoading();
        if (response.data.code == 200) {
            return response.data;
        } else if (response.data.status === 'OK') {
            return response.data;
        } else if (response.status == 200) {
            return response.data;
        }
    },
    error => {
        let unAuthorized = false;
        tryHideFullScreenLoading();
        index += 1;
        if (error.response) {
            switch (error.response.status) {
                case 400:
                    break;
                case 401:
                    unAuthorized = true;
                    break;
                case 403:
                    break;
                case 404:
                    break;
                case 422:
                    var errorMessage = "";
                    let errorData = error.response.data;
                    if (errorData != "") {
                        for (var item in errorData) {
                            errorMessage += errorData[item];
                        }
                        // Message.error(errorMessage);
                        // error.response.message = errorMessage;
                    }
                    break;
                case 500:
                    break;
            }
            if (unAuthorized && index == 1) {
                MessageBox.alert('授权码过期，请重新登录', '未授权', {
                    confirmButtonClass: '登录',
                    callback: action => {
                        localStorage.clear();
                        router.replace({
                            path: '/login',
                            query: {redirect: router.currentRoute.fullPath}
                        });
                        index = 0;
                        store.commit(types.TALGINDEX, index);
                    }
                });
            }
            return Promise.reject(error.response.data);
        } else {
            Message.error(error);
            return Promise.reject(error);
        }
    }
);
export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.config.js